import { render, staticRenderFns } from "./personPassGroupContent.vue?vue&type=template&id=6e33fd64&scoped=true"
import script from "./personPassGroupContent.vue?vue&type=script&lang=js"
export * from "./personPassGroupContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e33fd64",
  null
  
)

export default component.exports